import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolicyOverviewPageComponent } from '@htx/policies';

@NgModule({
  declarations: [],
  imports: [CommonModule, PolicyOverviewPageComponent],
  exports: [PolicyOverviewPageComponent]
})
export class OverviewModule {}
